import { useState } from "react";

import cx from "@hsl/core/utils/cx";

import ControlledCollapsible from "../../Collapsible";
import { type Props as TooltipProps } from "../../Tooltip/Tooltip";
import { CheckboxListLabel } from "./CheckboxListLabel";

export interface Props {
    containerClassName?: string;
    children: React.ReactNode;
    isOpen?: boolean;
    title: React.ReactNode;
    tooltip?: TooltipProps;
}

const CheckboxList = ({
    children,
    containerClassName,
    isOpen,
    title,
    tooltip,
}: Props) => {
    const [open, setOpen] = useState(isOpen);
    const toggleOpen = () => setOpen(!open);
    return (
        <div className={cx("border-platinum border-b", containerClassName)}>
            <ControlledCollapsible
                label={
                    <CheckboxListLabel
                        title={title}
                        toggleOpen={toggleOpen}
                        isOpen={open}
                        tooltip={tooltip}
                    />
                }
                labelAs="div"
                labelClassNames="w-full justify-between cursor-pointer py-0"
                isOpen={open}
            >
                {children}
            </ControlledCollapsible>
        </div>
    );
};

export default CheckboxList;
